import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import {
  IS_AUTH,
  USER_INFO,
  ID_TOKEN,
  REFRESH_TOKEN
} from '../../../settings/constants';
import webStorage from '../../../utils/webStorageClient';

const isAuthFromStorage: boolean = webStorage.get(IS_AUTH);
const userInfoFromStorage: object = webStorage.get(USER_INFO);

export interface AuthInterface {
  isAuth: boolean;
  userInfo: any;
  error: any;
}

const initialState: AuthInterface = {
  isAuth: isAuthFromStorage || false,
  userInfo: userInfoFromStorage || {},
  error: {}
};

const authSlice = createSlice({
  name: 'auth',
  initialState: initialState,

  reducers: {
    actionLogin: (state,action: PayloadAction<any>) => {
      state.isAuth = action.payload?.isAuth;
      state.userInfo = action.payload?.userInfo;
      webStorage.set(IS_AUTH, action.payload?.isAuth);
      webStorage.set(ID_TOKEN, action.payload?.id_token);
      webStorage.setToken(action.payload?.accessToken);
      webStorage.set(REFRESH_TOKEN, action.payload?.refresh_token);
      webStorage.set(USER_INFO, action.payload?.userInfo);
    },

    actionLogout: state => {
      state.isAuth = false;
      state.userInfo = {};
      state.error = {};
      webStorage.removeAll();
    }
  },

  extraReducers: {}
});

export const { actionLogin, actionLogout } = authSlice.actions;
export default authSlice.reducer;
